export const underscoreToCamelCase = (underscoreCasedStr: string): string => {
  return underscoreCasedStr.replace(/_.?/g, (part) =>
    part && part[1] ? part[1].toUpperCase() : ''
  );
};
